"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicSharingContract = void 0;
const contract_1 = require("../base/contract");
const sharing_schemas_1 = require("../../schemas/public/sharing.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
/**
 * Public Sharing Contract
 *
 * PRD Notes (FR45-50):
 * - GET is unauthenticated - anyone with link can view coupon preview
 */
exports.PublicSharingContract = (0, contract_1.createContract)({
    name: 'PublicSharing',
    baseUrl: '/shared',
    version: '1',
    serviceModule: 'coupon',
    endpoints: {
        getSharedCoupon: {
            method: 'GET',
            path: '/:shareCode',
            body: null,
            query: null,
            params: sharing_schemas_1.getSharedCouponParamsSchema,
            headers: null,
            response: {
                success: sharing_schemas_1.getSharedCouponResponseSchema,
                errors: {
                    notFound: api_schemas_1.baseErrorResponseSchema, // Share code not found
                },
            },
            middleware: [], // No auth required
            documentation: {
                summary: 'Get shared coupon preview',
                description: 'Retrieves public preview of a shared coupon. No authentication required. Shows coupon details, merchant info, and claim status.',
                tags: ['Public', 'Sharing'],
                deprecated: false,
            },
            tests: [
                'should return coupon preview without auth',
                'should return 404 for non-existent share code',
                'should indicate if coupon is expired',
                'should indicate if coupon is already claimed',
            ],
        },
    },
});
